/**
 * WEB-08 composer attachment token. The composer uploads through /api/inputs and
 * puts this opaque token (never a Host path) on the `输入文件:` line; the Host
 * materializes it into the sandbox attachment staging area for the turn.
 * Format: `hostinput:<turnId>/<inputRef>/<displayFileName>` (file name is display-only).
 */
export const HOST_INPUT_ATTACHMENT_PREFIX = 'hostinput:';

/**
 * New chats have no session before the first send, so the composer uploads into
 * a per-user draft scope (tenant-isolated by the Host) with a `draft-` turn id.
 * The Host materializes such tokens into whichever session the first send creates.
 * Must match HOST_INPUT_DRAFT_SESSION_ID in src/server/libs/hostInputAttachments.ts.
 */
export const HOST_INPUT_DRAFT_SESSION_ID = 'composer-draft';
export const HOST_INPUT_DRAFT_TURN_PREFIX = 'draft-';

export function buildHostInputDraftTurnId(uuid: string): string {
  return `${HOST_INPUT_DRAFT_TURN_PREFIX}${uuid}`;
}

export function buildHostInputAttachmentToken(input: {
  turnId: string;
  inputRef: string;
  fileName: string;
}): string {
  const name = input.fileName.replace(/[\r\n/\\]/g, '_');
  return `${HOST_INPUT_ATTACHMENT_PREFIX}${input.turnId}/${input.inputRef}/${name}`;
}

/**
 * 根据附件标识构造预览/下载地址；新输入携带会话作用域，历史文件保留原接口。
 * sessionId 缺失时由输入接口拒绝，不能把不透明标识降级为主机文件路径。
 */
export function buildAttachmentAccessUrl(
  filePath: string, sessionId?: string, action: 'read' | 'download' = 'read',
): string {
  if (filePath.startsWith(HOST_INPUT_ATTACHMENT_PREFIX)) {
    return `/api/inputs/${action}?${new URLSearchParams({ sessionId: sessionId ?? '', token: filePath })}`;
  }
  return `/api/files/${action}?path=${encodeURIComponent(filePath)}`;
}
